import ApartmentSharpIcon from "@mui/icons-material/ApartmentSharp";
import {
  ListItemText,
  ListItemAvatar,
  ListItemButton,
  Box,
  Stack,
} from "@mui/material";
import { Avatar, Grid } from "@mui/material";
import numberFormatter from "components/shared/numberFormatter";
import {
  LabelValueForText,
  LabelValueForTags,
} from "components/ui/atoms/LabelValue";
import { ColorTag, InvestmentStatusTag } from "components/ui/atoms/Tag";
import LimitedTextBox from "components/ui/atoms/LimitedTextBox";
import { TextTagForLabelValue } from "components/ui/atoms/LabelValue";

const DealListItemForSearch = ({ deal, onClick }) => {
  return (
    <ListItemButton
      onClick={() => onClick(deal.id)}
      sx={{ flexWrap: { xs: "wrap", md: "nowrap" } }}
    >
      <ListItemAvatar>
        <Avatar
          src={`http://logo.clearbit.com/${deal.company_detail.best_domain}`}
        >
          <ApartmentSharpIcon />
        </Avatar>
      </ListItemAvatar>
      <Stack
        direction={{ xs: "row", md: "column" }}
        alignItems={{ xs: "center", md: "start" }}
        spacing={0}
        sx={{
          width: { xs: "calc(100% - 56px)", md: "20%" },
          maxWidth: { xs: "auto", md: "250px" },
          flexGrow: 0,
          flexShrink: 0,
        }}
      >
        <ListItemText
          primary={deal.company_detail.best_name}
          secondary={
            <>
              {deal.deal_flow_detail.short_name}
              {" - "}
              {deal?.deal_owner_detail?.initials}{" "}
              {deal?.deal_owner_detail?.initials &&
              deal?.secondary_owner_detail?.initials
                ? ", " + deal?.secondary_owner_detail?.initials
                : null}
            </>
          }
        />
        <InvestmentStatusTag status={deal.investment_status} />
      </Stack>
      <Box
        sx={{
          width: { xs: "100%", md: "40%" },
          ml: { xs: 0, md: 2 },
          alignSelf: "stretch",
        }}
      >
        <LimitedTextBox
          title="Description"
          content={deal.company_detail?.description}
          limit={5}
        />
      </Box>
      <Box
        sx={{
          width: { xs: "100%", md: "40%" },
          maxWidth: { md: 500 },
          ml: { xs: 0, md: 2 },
          flexShrink: 0,
          flexGrow: 0,
        }}
      >
        <Grid container spacing={{ xs: 0, md: 3 }} p={0}>
          <Grid size={{ xs: 12, md: 6 }}>
            <LabelValueForText
              label="Country"
              value={deal.company_detail?.headquarter_address?.country_str}
              isMissing={deal.company_detail?.headquarter_address === null}
              variant="ForListItem"
            />
            <LabelValueForTags
              label="Team sources"
              Tags={deal.team_sources.map((team_source) => (
                <TextTagForLabelValue text={team_source.label} />
              ))}
              variant="ForListItem"
              maxTags={1}
              sx={{ mb: 0.5 }}
            />
            <LabelValueForText
              label="Introduced by"
              value={deal?.contributor_people_detail?.[0]?.fullname}
              isMissing={deal.contributor_people_detail.length === 0}
              variant="ForListItem"
            />
            <LabelValueForText
              label="Fundraiser"
              value={deal?.intermediary}
              isMissing={
                deal.intermediary === null || deal.intermediary.trim() === ""
              }
              variant="ForListItem"
            />
          </Grid>
          <Grid size={{ xs: 12, md: 6 }}>
            <LabelValueForText
              label="Revenues"
              value={`${numberFormatter(deal.reference_revenue || NaN)}€ (${
                deal.reference_revenue_year
              })`}
              isMissing={deal.reference_revenue === null}
              variant="ForListItem"
            />
            <LabelValueForText
              label="Requested amount"
              value={`${numberFormatter(deal.requested_amount || NaN)}€`}
              isMissing={deal.requested_amount === null}
              variant="ForListItem"
            />
            <LabelValueForText
              label="Profitable"
              value={deal?.profitable ? "Yes" : "No"}
              isMissing={deal.profitable === null}
              variant="ForListItem"
            />
            <LabelValueForTags
              label="Lost / Drop reason"
              Tags={
                deal?.reason_to_close_tag
                  ? deal?.reason_to_close_tag.map((r) => (
                      <ColorTag key={r} tagId={r} />
                    ))
                  : []
              }
              maxTags={1}
              variant="ForListItem"
            />
          </Grid>
        </Grid>
      </Box>
    </ListItemButton>
  );
};

export default DealListItemForSearch;
